import { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import CalcShell from "../../components/CalcShell";
import CalcField from "../../components/CalcField";
import { formatINR } from "../../utils/format";

const meta = { slug: "compound-interest", emoji: "🔁", title: "Compound Interest Calculator", desc: "The 8th wonder of the world, quantified." };

const FREQ = { 1: "Yearly", 2: "Half-yearly", 4: "Quarterly", 12: "Monthly" };

function CompoundInterestCalculator() {
  const [principal, setPrincipal] = useState(100000);
  const [rate, setRate] = useState(10);
  const [years, setYears] = useState(10);
  const [freq, setFreq] = useState(1);

  const amount = principal * Math.pow(1 + rate / 100 / freq, freq * years);
  const interest = amount - principal;

  return (
    <CalcShell
      meta={meta}
      note={
        <span>
          <strong>Albert Einstein</strong> reportedly called compound interest the
          eighth wonder of the world: "He who understands it, earns it; he who
          doesn't, pays it."
        </span>
      }
    >
      <Row>
        <Col md={6}>
          <CalcField label="Principal amount (₹)" value={principal} onChange={setPrincipal} min={1000} max={10000000} step={1000} prefix="₹" />
          <CalcField label="Interest rate (% p.a.)" value={rate} onChange={setRate} min={1} max={30} step={0.5} suffix="%" />
          <CalcField label="Time period (years)" value={years} onChange={setYears} min={1} max={40} step={1} suffix="yr" />
          <Form.Group className="mb-2">
            <Form.Label className="fw-semibold">Compounding frequency</Form.Label>
            <Form.Select value={freq} onChange={(e) => setFreq(Number(e.target.value))}>
              {Object.entries(FREQ).map(([k, v]) => (
                <option key={k} value={k}>{v}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={6}>
          <div className="fi-calc-result mb-3">
            <div>Final amount</div>
            <div className="big">{formatINR(amount)}</div>
          </div>
          <Row className="g-3">
            <Col xs={6}>
              <div className="fi-stat">
                <div className="num">{formatINR(principal)}</div>
                <small className="text-muted">Principal</small>
              </div>
            </Col>
            <Col xs={6}>
              <div className="fi-stat">
                <div className="num">{formatINR(interest)}</div>
                <small className="text-muted">Interest</small>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </CalcShell>
  );
}

export default CompoundInterestCalculator;
